<template>
  <v-card>
    <v-card-title>Will verification</v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="6">
          <VerifyUploadedWill
            :testator="testator"
            @refreshTestator="refreshTestator"
          />
        </v-col>

        <v-col cols="12" md="6">
          <AdminUploadWill :testator="testator" />
        </v-col>
        <v-col v-if="isAdmin" cols="12" md="12">
          <!-- This is temporarily being hidden from call center agents -->
          <div v-if="hasLegacyVaultedWill" class="legacy-vaulted py-4">
            <h3>Legacy Vaulted Will</h3>
            <p class="mb-0">
              This testator's will was vaulted under the legacy storage process
              on {{ legacyVaultedOn }}.
            </p>
          </div>
          <WillHistory :testator="testator" />
        </v-col>
      </v-row>

      <v-row v-if="testator.activeWillCollectionBooking">
        <v-col cols="12">
          <v-divider class="my-6" />

          <h2>Will Collection Booking</h2>
          <div class="booking-details">
            <div class="booking-detail">
              <strong>Expected Collection:</strong>
              {{ testator.activeWillCollectionBooking.collectionDetails }}
            </div>
            <div
              v-if="testator.activeWillCollectionBooking.deliveryDetails"
              class="booking-detail"
            >
              <strong>Estimated Delivery:</strong>
              {{ testator.activeWillCollectionBooking.deliveryDetails }}
            </div>
            <div
              v-if="latestWillCollectionBooking.trackingNumber"
              class="booking-detail"
            >
              <strong>Tracking Number:</strong>
              {{ latestWillCollectionBooking.trackingNumber }}
            </div>
            <div
              v-if="testator.activeWillCollectionBooking.statusDisplayName"
              class="booking-detail"
            >
              <strong>Status:</strong>
              {{ testator.activeWillCollectionBooking.statusDisplayName }}
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- <v-row v-if="latestValidUpload">
        <v-col cols="12">
          <v-divider class="my-6" />

          <h2>Latest valid will</h2>
          <v-btn
            rounded
            depressed
            large
            color="secondary"
            class="ml-0"
            @click="navigateToUploadedWill(latestValidUpload.id)"
            >View the most recent valid will</v-btn
          >
        </v-col>
      </v-row> -->
    </v-card-text>
  </v-card>
</template>

<script>
  import { latestValidUploadedWill } from '../../../constants/js/will-verification';
  import AdminUploadWill from './will_verification/AdminUploadWill.vue';
  import VerifyUploadedWill from './will_verification/VerifyUploadedWill.vue';
  import WillHistory from './WillHistory.vue';
  import { CREATE_UPLOADED_WILL_PRESIGNED_URL_MUTATION } from '../../../constants/graphql/will-verifications';

  export default {
    name: 'WillVerificationBlock',
    components: {
      AdminUploadWill,
      VerifyUploadedWill,
      WillHistory,
    },
    props: {
      testator: {
        required: true,
        type: Object,
      },
    },
    computed: {
      latestValidUpload() {
        return latestValidUploadedWill(this.testator.willVersions);
      },
      latestWillCollectionBooking() {
        return this.testator.latestWillCollectionBooking || null;
      },
      hasLegacyVaultedWill() {
        if (!this.testator.dateStored) return false;
        return !this.testator.willVersions?.some(version => version.dateStored);
      },
      legacyVaultedOn() {
        // date_stored is a date column serialized as iso8601 (yyyy-mm-dd),
        // so it can be shown as-is without Date parsing (Safari-safe).
        return (this.testator.dateStored || '').split('T')[0];
      },
      isAdmin() {
        return this.$store.getters.isAdmin;
      },
    },
    methods: {
      refreshTestator() {
        this.$emit('refreshTestator');
      },
      navigateToUploadedWill(id) {
        var newTab = window.open('', '_blank');
        this.$apollo
          .mutate({
            mutation: CREATE_UPLOADED_WILL_PRESIGNED_URL_MUTATION,
            variables: {
              id,
            },
          })
          .then(response => {
            newTab.location.href = response.data.createUploadedWillPresignedUrl;
          });
      },
      formatCollectionDate(dateString) {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .booking-details {
    margin-top: 16px;
  }

  .legacy-vaulted {
    h3 {
      margin-bottom: 12px;
    }
  }

  .booking-detail {
    margin-bottom: 8px;
    padding: 8px 0;
    border-bottom: 1px solid #e0e0e0;

    &:last-child {
      border-bottom: none;
    }
  }
</style>
